import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const NoEducationIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 40 34" {...props}>
      <path
        d="M39.0234 6.67653L20.2887 0.0664653C20.0377 -0.0221551 19.7638 -0.0221551 19.5128 0.0664653L0.77815 6.67653C0.312349 6.84087 0.000622829 7.28086 9.31838e-07 7.7748C-0.000620966 8.26875 0.310095 8.70944 0.775507 8.87486L19.5102 15.5351C19.6365 15.5801 19.7686 15.6025 19.9007 15.6025C20.0329 15.6025 20.1649 15.5801 20.2913 15.5351L39.0259 8.87486C39.4913 8.70944 39.802 8.26875 39.8014 7.7748C39.8008 7.28086 39.4891 6.84087 39.0234 6.67653Z"
        fill="#C0C5CD"
      />
      <path
        d="M37.0011 22.2405V12.0693L34.6689 12.8984V22.2405C33.9665 22.6448 33.4932 23.4023 33.4932 24.271C33.4932 25.1397 33.9665 25.8973 34.6689 26.3016V32.0321C34.6689 32.6761 35.191 33.1981 35.835 33.1981C36.479 33.1981 37.0011 32.6761 37.0011 32.0321V26.3017C37.7035 25.8975 38.1768 25.1398 38.1768 24.2711C38.1768 23.4024 37.7036 22.6448 37.0011 22.2405Z"
        fill="#C0C5CD"
      />
      <path
        d="M19.9001 17.9346C19.4998 17.9346 19.1056 17.8666 18.7284 17.7325L8.19629 13.9883V19.1196C8.19629 20.3749 9.50593 21.4366 12.0888 22.2749C14.3402 23.0056 17.1143 23.4081 19.9001 23.4081C22.6859 23.4081 25.4599 23.0056 27.7113 22.2749C30.2942 21.4366 31.6039 20.3749 31.6039 19.1196V13.9883L21.0719 17.7325C20.6946 17.8666 20.3004 17.9346 19.9001 17.9346Z"
        fill="#C0C5CD"
      />
    </SvgIcon>
  );
};

export default NoEducationIcon;
